import React from "react";
import styled from "styled-components";
import { prefix } from "../../../config";

const Border = styled.div``;

function getBorderStyle(color) {
    return { backgroundColor: color.bg };
}

const Borders = ({ color }) => {
    return (
        <>
            <Border
                style={getBorderStyle(color)}
                className={`${prefix}-controls-border ${prefix}-controls-border-left`}
            />
            <Border
                style={getBorderStyle(color)}
                className={`${prefix}-controls-border ${prefix}-controls-border-right`}
            />
            <Border
                style={getBorderStyle(color)}
                className={`${prefix}-controls-border ${prefix}-controls-border-top`}
            />
            <Border
                style={getBorderStyle(color)}
                className={`${prefix}-controls-border ${prefix}-controls-border-bottom`}
            />
        </>
    );
};
export default Borders;
